define('views/shared/form/input/email_mute_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/email_mute_component.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'form-input',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {},

        initialize: function(options){
            options = options || {};

            this.field = options.field;

            this.is_valid = true;
            this.error = false;

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            this.render();

            this.updateValue(this.field.placeholder);
            
        },

        updateValue: function(text){
            this.$el.find('input').attr('placeholder', text);
            this.$el.find('input').val(text);
        },

        getValue: function(){
            
            if(this.field.encrypt){
                return encrypt(this.$el.find('input').val());
            } else {
                return this.$el.find('input').val();
            }
            
        },

        showError: function(){
            // console.log('email_mute_component showError',this);
            // var feedback = this.error_feedback || this.field.error.empty;

            // this.error = true;
            // this.$el.find('.js-form-input-feedback').html(feedback);
        },

        removeError: function(){
            this.error = false;
            this.$el.find('.js-form-input-feedback').html('');
        },

        close: function(){}
    });
});

